import React, { useEffect, useState } from "react";
import FormGraficoEvolucaoGenetica from "./Form/FormGraficoEvolucaoGenetica";

import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { actions } from "../../redux/actions";
import AvaliacaoGeneticaService from "../../services/AvaliacaoGeneticaService";
import EvolucaoGeneticaService from "../../services/EvolucaoGeneticaService";
import { graphMockedData } from "./Grafico/MockedGraphData";

import { CaracteristicasInterface } from "./Form/Caracteristicas";

import {
  Fazenda,
  Raca,
  Sexo,
  Categoria,
  Caracteristica,
  Variedade,
} from "../../types";

interface dynamicObjectKey {
  [key: string]: any;
}

const GraficoEvolucaoGenetica: React.FC<any> = () => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [fazendas, setFazendas] = useState<Array<Fazenda>>([]);
  const [racas, setRacas] = useState<Array<Raca>>([]);
  const [sexos, setSexos] = useState<Array<Sexo>>([]);
  const [categorias, setCategorias] = useState<Array<Categoria>>([]);
  const [caracteristicas, setCaracteristicas] = useState<
    Array<CaracteristicasInterface>
  >([]);
  const [paises, setPaises] = useState([]);
  const [variedades, setVariedades] = useState<Array<Variedade>>([]);
  const [graphData, setGraphData] = useState<any>([]);

  const [consulta] = useState({});

  const getFazendas = () => {
    AvaliacaoGeneticaService.fazendas()
      .then((response) => {
        if (response && response.length > 0) {
          setFazendas(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getRacas = () => {
    AvaliacaoGeneticaService.racas()
      .then((response) => {
        if (response && response.length > 0) {
          setRacas(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getCategorias = () => {
    AvaliacaoGeneticaService.categorias()
      .then((response) => {
        if (response && response.length > 0) {
          setCategorias(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getPaises = () => {
    AvaliacaoGeneticaService.paises()
      .then((response) => {
        if (response && response.length > 0) {
          setPaises(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getVariedades = () => {
    AvaliacaoGeneticaService.variedades()
      .then((response) => {
        if (response && response.length > 0) {
          setVariedades(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getSexos = () => {
    AvaliacaoGeneticaService.sexos()
      .then((response) => {
        if (response && response.length > 0) {
          setSexos(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const filtrar = (obj: dynamicObjectKey) => {
    setLoading(true);
    EvolucaoGeneticaService.filtrar(obj)
      .then((response) => {
        setGraphData(response);
        setLoading(false);
        dispatch(actions.addNewPageFilter("grafico"));
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const send = (obj: dynamicObjectKey) => {
    if (obj && Object.keys(obj).length > 0) {
      Object.keys(obj).map(function (key, index) {
        if (key !== "Page" && obj[key] !== undefined && obj[key] !== null) {
          obj[key] = obj[key].toString();
        }
        return obj;
      });
    }
    filtrar(obj);
  };

  const onRacaSelected = (raca: Raca) => {
    getCaracteristicas(raca.id);
  };

  const getCaracteristicas = (racaId: number) => {
    setLoading(true);

    AvaliacaoGeneticaService.caracteristicasAgrupadas(racaId)
      .then((response) => {
        if (response && response.length > 0) {
          setCaracteristicas(response);
        }

        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const setMockedGraphData = () => {
    setGraphData(graphMockedData);
  };

  useEffect(() => {
    setLoading(true);
    // setMockedGraphData();
    getFazendas();
    getRacas();
    getCategorias();
    getVariedades();
    getSexos();
    getPaises();

    dispatch(actions.addNewTitle("Gráfico de Evolução Genética"));
  }, []);

  return (
    <div className="avaliacao-genetica">
      {loading && (
        <div className={"loading-mask"}>
          <FontAwesomeIcon icon={faCircleNotch} pulse />
        </div>
      )}

      <FormGraficoEvolucaoGenetica
        fazendas={fazendas}
        racas={racas}
        sexos={sexos}
        categorias={categorias}
        variedades={variedades}
        initialConsulta={consulta}
        caracteristicas={caracteristicas}
        graphData={graphData}
        send={send}
        onRacaSelected={onRacaSelected}
        paises={paises}
      ></FormGraficoEvolucaoGenetica>
    </div>
  );
};

export default GraficoEvolucaoGenetica;
